import { SearchOff } from "@mui/icons-material";
import { Box, Typography } from "@mui/material";

interface IEmptySearchResultsProps {
    title: string;
    description: string;
}

const EmptySearchResults: React.FC<IEmptySearchResultsProps> = (props: IEmptySearchResultsProps) => {
    return (
        <Box sx={{
            display: 'flex', 
            justifyContent: 'center', 
            alignItems: 'center', 
            height: '100%', 
            flexDirection: 'column', 
            margin: '1rem'}}
        >
            <SearchOff color="primary" sx={{fontSize: '4rem'}}/>
            <Typography>{props.title}</Typography>
            <Typography variant="caption">{props.description}</Typography>
        </Box>
    );
}

export default EmptySearchResults;